import { ID } from '@/data/types/Basic';

export const EMARSYS_WIDGET_NAME = 'hdm-emarsys-product-recommendation-widget';
type Emarsys = {
	[key: string]: string[];
};
export const generateEmarsysRequestValues = (
	pageName: ID,
	emarsysProductType: string,
	physicalStoreId: string
) => {
	const additionalObj: Emarsys = {
		HomePage: [`HOME_${physicalStoreId}`, 'Nuestras recomendaciones para ti'],
		'nextjs-home': [`HOME_${physicalStoreId}`, 'Nuestras recomendaciones para ti'],
		home: [`HOME_${physicalStoreId}`, 'Nuestras recomendaciones para ti'],
		CATEGORY_PAGE: [`POPULAR_${physicalStoreId}`, 'Los más vendidos'],
		searchPage: [`SEARCH_${physicalStoreId}`, 'Recomendados para tu búsqueda'],
		CartPage: [`CART_${physicalStoreId}`, 'Complementa tu proyecto'],
		PRODUCT_PAGE: [`ALSO_BOUGHT_${physicalStoreId}`, 'Otros clientes también compraron'],
	};
	const regularlObj: Emarsys = {
		HomePage: [`PERSONAL_${physicalStoreId}`, 'Especiales para ti'],
		'nextjs-home': [`PERSONAL_${physicalStoreId}`, 'Especiales para ti'],
		home: [`PERSONAL_${physicalStoreId}`, 'Especiales para ti'],
		CATEGORY_PAGE: [`CATEGORY_${physicalStoreId}`, 'Productos que podrían interesarte'],
		PRODUCT_PAGE: [`RELATED_${physicalStoreId}`, 'Parecidos a este producto'],
		searchPage: [`PERSONAL_${physicalStoreId}`, 'Nuestras recomendaciones para ti'],
		CartPage: [`PERSONAL_${physicalStoreId}`, 'Nuestras recomendaciones para ti'],
	};
	const emptyReturn = ['', ''];

	return emarsysProductType === EMARSYS_TYPE.ADDITIONAL
		? additionalObj[pageName] ?? emptyReturn
		: emarsysProductType === EMARSYS_TYPE.REGULAR
		? regularlObj[pageName] ?? emptyReturn
		: emptyReturn;
};

export const getEmarsysTag = (containerName: string, identifier: string): string[] => {
	const containerValues: Emarsys = {
		'product-listing-page': identifier === 's' ? SEARCH_TAG : CATEGORY_TAG,
		'category-landing-page': CATEGORY_TAG,
		'product-page': PDP_TAG,
		'kit-page': PDP_TAG,
	};
	return containerValues[containerName] ?? HOME_TAG;
};

export const URLS_PAGES = {
	HOME_PAGE: 'HomePage',
	HOME: 'home',
	CART_PAGE: 'CartPage',
	NEXTJS_HOME: 'nextjs-home',
	PLP_PAGE: 'ProductListPage',
	CATEGORY_PAGE_TYPE: 'CategoryPage',
	CATEGORY_PAGE: 'CATEGORY_PAGE',
	PRODUCT_PAGE: 'PRODUCT_PAGE',
	SEARCH: 'search',
	SEARCH_PAGE: 'searchPage',
};

export const EMARSYS_TYPE = {
	REGULAR: 'regular',
	ADDITIONAL: 'additional',
};

export const EMARSYS_TAGS = {
	AVL_ZONE: 'availabilityZone',
	CART: 'cart',
	SEARCH_TERM: 'searchTerm',
	TAG_SEARCH: 'tagSearch',
	SET_EMAIL: 'setEmail',
	PURCHASE: 'purchase',
	SET_CUSTOMERID: 'setCustomerId',
	CATEGORY: 'category',
	VIEW: 'view',
	TAG_CATEGORY: 'tagCategory',
};

export const EMARSYS_PAGES_PREFIX = {
	PRODUCT_PAGE: '/p/',
	BUNDLE_PAGE: '/g/',
	CATALOG_PAGE: '/b/',
};

export const URLS_CONTAINER_PAGES = {
	PRODUCT_PAGE: 'product-page',
	KIT_PAGE: 'kit-page',
	CATEGORY_LAND_PAGE: 'category-landing-page',
	PLP: 'product-listing-page',
	THANK_U_PAGE: 'order-confirmation-page',
};

export const HOME_TAG = [EMARSYS_TAGS.AVL_ZONE, EMARSYS_TAGS.CART];
export const CART_TAG = [EMARSYS_TAGS.AVL_ZONE, EMARSYS_TAGS.CART];
export const SEARCH_TAG = [
	EMARSYS_TAGS.AVL_ZONE,
	EMARSYS_TAGS.CART,
	EMARSYS_TAGS.SEARCH_TERM,
	EMARSYS_TAGS.TAG_SEARCH,
];
export const CATEGORY_TAG = [
	EMARSYS_TAGS.AVL_ZONE,
	EMARSYS_TAGS.CART,
	EMARSYS_TAGS.CATEGORY,
	EMARSYS_TAGS.TAG_CATEGORY,
];
export const PDP_TAG = [EMARSYS_TAGS.AVL_ZONE, EMARSYS_TAGS.CART, EMARSYS_TAGS.VIEW];
